import script from "./sw-item-editor-pulldown.vue?vue&type=script&setup=true&lang=js"
export * from "./sw-item-editor-pulldown.vue?vue&type=script&setup=true&lang=js"

import "./sw-item-editor-pulldown.vue?vue&type=style&index=0&id=f97e7c68&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f97e7c68"]])

export default __exports__